import { useEffect, useState } from 'react';

interface Route {
  path: string;
  component: React.ComponentType;
}

interface RouterProps {
  routes: Route[];
}

/**
 * Simple client-side router component
 * Uses browser location to determine which component to render
 */
export function Router({ routes }: RouterProps) {
  const [currentPath, setCurrentPath] = useState(window.location.pathname);

  useEffect(() => {
    const handleLocationChange = () => {
      setCurrentPath(window.location.pathname);
    };

    // Listen for popstate (back/forward navigation)
    window.addEventListener('popstate', handleLocationChange);

    // Listen for custom navigation events
    window.addEventListener('navigate', handleLocationChange);

    return () => {
      window.removeEventListener('popstate', handleLocationChange);
      window.removeEventListener('navigate', handleLocationChange);
    };
  }, []);

  // Find matching route
  const route = routes.find(r => r.path === currentPath) || routes.find(r => r.path === '/');
  
  if (!route) {
    return <div>404 - Page not found</div>;
  }

  const Component = route.component;
  return <Component />;
}

/**
 * Navigate to a new path
 */
export function navigate(path: string) {
  window.history.pushState({}, '', path);
  window.dispatchEvent(new Event('navigate'));
}
